/**
 * URL base pública do MercadoPagu.
 *
 * IMPORTANTE: sempre use esta constante ao gerar links que são
 * exibidos, copiados ou compartilhados pelo usuário (links de venda,
 * área do membro, afiliado, pagamento etc).
 *
 * Nunca use window.location.origin para esses casos, pois em ambientes
 * de preview (ex: fintech-marketplace-5.preview.emergentagent.com)
 * o link gerado ficaria com o domínio errado e não funcionaria
 * quando aberto pelo cliente final.
 *
 * Uso técnico interno (redirects, OAuth callback dentro da SPA) DEVE
 * continuar usando window.location.origin.
 */
export const PUBLIC_BASE_URL = (process.env.REACT_APP_PUBLIC_URL || "").replace(/\/+$/, "");

/**
 * Junta o base público com um path relativo, evitando barras duplicadas.
 * Ex: publicUrl("/f/meu-funil") → "https://mercadopagu.com.br/f/meu-funil"
 */
export function publicUrl(path = "") {
  if (!path) return PUBLIC_BASE_URL;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${PUBLIC_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
